// Photo dedup + storage-path identity. The photoKey becomes the object path's
// last segment and, via the server storage trigger, the Firestore doc id — so
// the SAME physical photo must produce the SAME key on every upload, or dedup
// fails and we double-store.
//
// Shape: `${captureSeconds}-${file.size}-${sanitizedName}` — built by the
// shared `upload/objectKeys` helper, which the footage-video keys also use so
// the two ingest flows can never drift apart on sanitization or truncation.
//
//   - captureSeconds is a STABLE capture time in whole seconds. It comes from
//     EXIF (passed in by the scanner); when EXIF is absent it's 0. We do NOT
//     use file.lastModified: browsers re-stamp it with ~1ms jitter on each
//     folder drop, which gave the same photo a different key on re-upload.

import { MAX_OBJECT_KEY_LENGTH, buildObjectKey, sanitizeFileName as sanitize } from '../upload/objectKeys';

export const MAX_PHOTO_KEY_LENGTH = MAX_OBJECT_KEY_LENGTH;

export function sanitizeFileName(name) {
  return sanitize(name, { fallback: 'photo' });
}

export function buildPhotoKey(file, { capturedAtMs } = {}) {
  if (!file) throw new Error('buildPhotoKey: file is required');
  return buildObjectKey(file, {
    stableAtMs: capturedAtMs,
    maxLength: MAX_PHOTO_KEY_LENGTH,
    fallbackName: 'photo',
  });
}

// Convenience: storage paths + Firestore doc id all derive from the same key.
export function photoStoragePath(uid, projectId, photoKey) {
  return `photos/${uid}/${projectId}/${photoKey}`;
}

export function photoThumbPath(uid, projectId, photoKey) {
  return `photo_thumbs/${uid}/${projectId}/${photoKey}.jpg`;
}
